import { TradeHistoryApiWs, type ChanelActionType, type TradeWSUpdate } from "@trading/infrastructure";

export default class TradeHistoryService {
  constructor(private repo: TradeHistoryApiWs) {
  }

  async subscribeToTradesChannel(
    actionName: ChanelActionType,
    cb: (trade: TradeWSUpdate) => void
  ): Promise<undefined | CallableFunction> {
    return await this.repo.subscribeToChannelsAction(actionName, cb)
  }

  unsubscribe(): void {
    this.repo.unsubscribeToChannel()
  }
}
